import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { deleteCountries } from "../../../../../MyApi/sb/countries";
import { toast } from "react-toastify";
import icons from "../../../../../Data/icons";

const SingleCountry = ({ country, classes ,refetch,lang }) => {
  const { id,name, phone_code, currency, code } = country;

  const navigate = useNavigate()

  const EditPen = icons.pen

const mutation =useMutation(["deletecountry" ,id ,lang] ,()=>deleteCountries(id,lang),
{
  onSuccess:(data)=>{
 toast.success(`${data.message}`)
 refetch()
  },
  onError:(error)=>{
  toast.error(`${error.data.response.message}`)
  }
})
const deletePost =()=>{
  mutation.mutate()
}
  return (
    <tr>
      <td className={classes.idTable}>{id}</td>
      <td>{name}</td>
      <td>{phone_code}</td>
      <td>{currency}</td>
      <td>{code}</td>
      <td >
          <div role="group" class="btn-group">
            <button class="btn btn-success" onClick={()=>navigate(`${process.env.PUBLIC_URL}/countries/${id}`)}><i class="fa fa-eye"></i></button>
            <button class="btn btn-secondary" onClick={()=>navigate(`${process.env.PUBLIC_URL}/currency/${id}`)}><EditPen/></button>
           <button class="btn btn-danger" onClick={deletePost}><i class="fa fa-trash"></i></button>
           </div>
      </td>
    </tr>
  );
};

export default SingleCountry;
